module.exports = __webpack_public_path__ + "static/media/134.2e174c10.jpg";